import { Box, Typography, Card, CardContent, Stepper, Step, StepLabel, StepContent, StepConnector, Paper, Divider, LinearProgress, Chip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { FaUserTie } from "react-icons/fa6";
import MarkingPeriodField from 'components/MarkingPeriodField';
import { useSession } from 'components/Providers';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMarkingPeriods } from 'store/lookup';
import NoRecords from 'components/NoRecords';
import { useTranslation } from 'react-i18next';

const CustomStepIcon = (props) => {
    const { color } = props;

    return (
        <Box
            sx={{
                width: 16,
                height: 16,
                borderRadius: '50%',
                bgcolor: color,
                mt: '4px'
            }}
        />
    );
};

const IncidentFeed = ({ incidents, }) => {
    const { t } = useTranslation();
    const { academicYear } = useSession();
    const { currentMarkingPeriodId } = useSelector(state => state.lookup);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!currentMarkingPeriodId) {
            dispatch(getMarkingPeriods({ id: academicYear?.id }));
        }
    }, [dispatch, academicYear]);

    if (!academicYear || !currentMarkingPeriodId) {
        return (
            <Box component={Paper} sx={{ p: 2 }}>
                <LinearProgress color="primary" />
            </Box>
        );
    }

    return (
        <Box component={Card} variant="outlined" sx={{ p: 2, borderRadius: 2, }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, maxHeight: 50 }}>
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>{t('Incidents')}</Typography>
                <MarkingPeriodField
                    label={t('Marking Period')}
                    academicYearId={academicYear?.id}
                    markingPeriodId={0}
                    includeAll={true}
                    width="50%"
                    size={"small"}
                    paddingTop={0}
                />
            </Box>
            <Divider sx={{ mb: 2 }} />

            <Box sx={{ maxHeight: 'calc(100vh - 225px)', overflowY: 'auto' }}>
                {incidents.length === 0 ? (
                    <NoRecords message={t('No incidents during the selected marking period.')} variant='body2' />
                ) : (
                    <Stepper orientation="vertical" connector={<StepConnector sx={{ ml: '7px' }} />}>
                        {incidents.map((incident, index) => (
                            <Step
                                key={index}
                                active={true}
                                expanded={true}
                                sx={{
                                    '& .MuiStepContent-root': { borderLeft: '1px solid', borderColor: 'divider', ml: '7px' },
                                }}
                            >
                                <StepLabel
                                    StepIconComponent={(props) => (
                                        <CustomStepIcon {...props} color={incident.points >= 0 ? 'success.main' : 'error.main'} />
                                    )}
                                >
                                    <Typography variant="caption" color="text.secondary">
                                        {incident.date}
                                    </Typography>
                                </StepLabel>

                                <StepContent>
                                    <Card variant="outlined" sx={{ bgcolor: 'action.hover', border: 'none', borderRadius: 2, }}>
                                        <CardContent sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, alignItems: 'center', p: '16px !important', }}>
                                            <Box>
                                                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                                    {incident.title}
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary">
                                                    {incident.description}
                                                </Typography>
                                                <Chip label={incident.staff} size="small" icon={<FaUserTie size={'16px'} />} sx={{ mt: 1 }} />
                                            </Box>

                                            <Box
                                                sx={{
                                                    bgcolor: theme => alpha(theme.palette[incident.points < 0 ? 'error' : 'success'].main, 0.12),
                                                    color: incident.points < 0 ? 'error.main' : 'success.main',
                                                    borderRadius: 1,
                                                    px: 2,
                                                    py: 1,
                                                    fontWeight: 'bold',
                                                    // minWidth: 40,
                                                    textAlign: 'center'
                                                }}
                                            >
                                                {incident.points > 0 ? `+${incident.points}` : incident.points}
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </StepContent>
                            </Step>
                        ))}
                    </Stepper>
                )}
            </Box>
        </Box>
    );
};

export default IncidentFeed;